import React from 'react';
import { colors } from 'styleguide';

interface Props {
  size?: number;
  color?: string;
}

const Block = ({ size = 16, color = colors('neutral', 3) }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="16"
      y="16"
      width="16"
      height="16"
      rx="2"
      transform="rotate(-180 16 16)"
      fill={color}
      stroke="none"
    />
  </svg>
);

export default Block;
